
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/embedded-menu/[cName]/brands/[brandId]",
      function () {
        return require("private-next-pages/embedded-menu/[cName]/brands/[brandId].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/embedded-menu/[cName]/brands/[brandId]"])
      });
    }
  